import script from "./MobileMainSection.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileMainSection.vue?vue&type=script&setup=true&lang=js"

import "./MobileMainSection.vue?vue&type=style&index=0&id=f58019ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f58019ce"]])

export default __exports__